<template>
  <v-dialog
    v-if="post"
    :value="dialog"
    :max-width="550"
    persistent
    :retain-focus="false"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card outlined>
      <v-card-title>
        {{ post.name }}
        <div class="text-no-wrap mr-n3 ml-auto">
          <p-btn-icon v-if="hasAccess()" type="edit" tabindex="4" @click="$parent.openEditDialog(post)"></p-btn-icon>
          <p-btn-icon type="close" tabindex="5" @click="closeDialog"></p-btn-icon>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="text--primary pt-4">
        <v-list>
          <v-list-item
            v-for="channel of channels"
            :key="channel.channelId"
            :href="channel.postUrl"
            :title="channel.postUrl"
            target="_blank"
          >
            <v-list-item-avatar>
              <p-social-media-icon
                :id="channel.socialMediaId"
                large
              ></p-social-media-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ channel.name }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon v-if="channel.postUrl">
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import { socialMedia } from '@/constants'

import PBtnIcon from '@/components/PBtnIcon'
import PSocialMediaIcon from '@/components/PSocialMediaIcon'

import dialogMixin from '@/mixins/dialog.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PBtnIcon,
    PSocialMediaIcon
  },


  mixins: [
    dialogMixin,
    accessMixin
  ],


  props: {
    post: Object
  },


  computed: {
    channels () {
      return this.post.channels.map(channel => {
        return {
          ...channel,
          postUrl: channel.responsePostId ? this.getPostUrl(channel) : null
        }
      })
    }
  },


  methods: {
    getPostUrl (channel) {
      switch (channel.socialMediaId) {
        case socialMedia.wordPress: {
          return new URL(`?p=${channel.responsePostId}`, channel.externalId).toString()
        }
      }
    }
  }
}
</script>
